import _defineProperty from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toConsumableArray from "D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import * as tslib_1 from "tslib";
import { isArray, isBoolean, isString } from 'vega-util';
import { isContinuous, isFieldDef } from '../channeldef';
import { fieldDefs } from '../encoding';
import * as log from '../log';
import { isMarkDef } from '../mark';
export function filterTooltipWithAggregatedField(oldEncoding) {
  var tooltip = oldEncoding.tooltip,
      filteredEncoding = tslib_1.__rest(oldEncoding, ["tooltip"]);

  if (!tooltip) {
    return {
      filteredEncoding: oldEncoding
    };
  }

  var customTooltipWithAggregatedField;
  var customTooltipWithoutAggregatedField;

  if (isArray(tooltip)) {
    tooltip.forEach(function (t) {
      if (t.aggregate) {
        if (!customTooltipWithAggregatedField) {
          customTooltipWithAggregatedField = [];
        }

        customTooltipWithAggregatedField.push(t);
      } else {
        if (!customTooltipWithoutAggregatedField) {
          customTooltipWithoutAggregatedField = [];
        }

        customTooltipWithoutAggregatedField.push(t);
      }
    });

    if (customTooltipWithAggregatedField) {
      filteredEncoding.tooltip = customTooltipWithAggregatedField;
    }
  } else {
    if (tooltip['aggregate']) {
      filteredEncoding.tooltip = tooltip;
    } else {
      customTooltipWithoutAggregatedField = tooltip;
    }
  }

  if (isArray(customTooltipWithoutAggregatedField) && customTooltipWithoutAggregatedField.length === 1) {
    customTooltipWithoutAggregatedField = customTooltipWithoutAggregatedField[0];
  }

  return {
    customTooltipWithoutAggregatedField: customTooltipWithoutAggregatedField,
    filteredEncoding: filteredEncoding
  };
}
export function getCompositeMarkTooltip(tooltipSummary, continuousAxisChannelDef, encodingWithoutContinuousAxis) {
  var withFieldName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var fiveSummaryTooltip = tooltipSummary.map(function (_ref) {
    var fieldPrefix = _ref.fieldPrefix,
        titlePrefix = _ref.titlePrefix;
    return {
      field: fieldPrefix + continuousAxisChannelDef.field,
      type: continuousAxisChannelDef.type,
      title: titlePrefix + (withFieldName ? ' of ' + continuousAxisChannelDef.field : '')
    };
  });
  return {
    tooltip: [].concat(_toConsumableArray(fiveSummaryTooltip), _toConsumableArray(fieldDefs(encodingWithoutContinuousAxis)))
  };
}
export function makeCompositeAggregatePartFactory(compositeMarkDef, continuousAxis, continuousAxisChannelDef, sharedEncoding, compositeMarkConfig) {
  var scale = continuousAxisChannelDef.scale,
      axis = continuousAxisChannelDef.axis;
  return function (_ref2) {
    var partName = _ref2.partName,
        mark = _ref2.mark,
        positionPrefix = _ref2.positionPrefix,
        _ref2$endPositionPref = _ref2.endPositionPrefix,
        endPositionPrefix = _ref2$endPositionPref === void 0 ? undefined : _ref2$endPositionPref,
        _ref2$extraEncoding = _ref2.extraEncoding,
        extraEncoding = _ref2$extraEncoding === void 0 ? {} : _ref2$extraEncoding;
    var title = axis && axis.title !== undefined ? undefined : continuousAxisChannelDef.title !== undefined ? continuousAxisChannelDef.title : continuousAxisChannelDef.field;
    return partLayerMixins(compositeMarkDef, partName, compositeMarkConfig, {
      mark: mark,
      encoding: Object.assign(_defineProperty({}, continuousAxis, Object.assign({
        field: positionPrefix + '_' + continuousAxisChannelDef.field,
        type: continuousAxisChannelDef.type
      }, title ? {
        title: title
      } : {}, scale ? {
        scale: scale
      } : {}, axis ? {
        axis: axis
      } : {})), isString(endPositionPrefix) ? _defineProperty({}, continuousAxis + '2', {
        field: endPositionPrefix + '_' + continuousAxisChannelDef.field,
        type: continuousAxisChannelDef.type
      }) : {}, sharedEncoding, extraEncoding)
    });
  };
}
export function partLayerMixins(markDef, part, compositeMarkConfig, partBaseSpec) {
  var clip = markDef.clip,
      color = markDef.color,
      opacity = markDef.opacity;
  var mark = markDef.type;

  if (markDef[part] || markDef[part] === undefined && compositeMarkConfig[part]) {
    return [Object.assign({}, partBaseSpec, {
      mark: Object.assign({}, compositeMarkConfig[part], clip ? {
        clip: clip
      } : {}, color ? {
        color: color
      } : {}, opacity ? {
        opacity: opacity
      } : {}, isMarkDef(partBaseSpec.mark) ? partBaseSpec.mark : {
        type: partBaseSpec.mark
      }, {
        style: "".concat(mark, "-").concat(part)
      }, isBoolean(markDef[part]) ? {} : markDef[part])
    })];
  }

  return [];
}
export function compositeMarkContinuousAxis(spec, orient, compositeMark) {
  var encoding = spec.encoding;
  var continuousAxis = orient === 'vertical' ? 'y' : 'x';
  var continuousAxisChannelDef = encoding[continuousAxis]; // Safe to cast because if x is not continuous fielddef, the orient would not be horizontal.

  var continuousAxisChannelDef2 = encoding[continuousAxis + '2'];
  var continuousAxisChannelDefError = encoding[continuousAxis + 'Error'];
  var continuousAxisChannelDefError2 = encoding[continuousAxis + 'Error2'];
  return {
    continuousAxisChannelDef: filterAggregateFromChannelDef(continuousAxisChannelDef, compositeMark),
    continuousAxisChannelDef2: filterAggregateFromChannelDef(continuousAxisChannelDef2, compositeMark),
    continuousAxisChannelDefError: filterAggregateFromChannelDef(continuousAxisChannelDefError, compositeMark),
    continuousAxisChannelDefError2: filterAggregateFromChannelDef(continuousAxisChannelDefError2, compositeMark),
    continuousAxis: continuousAxis
  };
}

function filterAggregateFromChannelDef(continuousAxisChannelDef, compositeMark) {
  if (continuousAxisChannelDef && continuousAxisChannelDef.aggregate) {
    var aggregate = continuousAxisChannelDef.aggregate,
        continuousAxisWithoutAggregate = tslib_1.__rest(continuousAxisChannelDef, ["aggregate"]);

    if (aggregate !== compositeMark) {
      log.warn(log.message.errorBarContinuousAxisHasCustomizedAggregate(aggregate, compositeMark));
    }

    return continuousAxisWithoutAggregate;
  } else {
    return continuousAxisChannelDef;
  }
}

export function compositeMarkOrient(spec, compositeMark) {
  var mark = spec.mark,
      encoding = spec.encoding;

  if (isFieldDef(encoding.x) && isContinuous(encoding.x)) {
    // x is continuous
    if (isFieldDef(encoding.y) && isContinuous(encoding.y)) {
      // both x and y are continuous
      if (encoding.x.aggregate === undefined && encoding.y.aggregate === compositeMark) {
        return 'vertical';
      } else if (encoding.y.aggregate === undefined && encoding.x.aggregate === compositeMark) {
        return 'horizontal';
      } else if (encoding.x.aggregate === compositeMark && encoding.y.aggregate === compositeMark) {
        throw new Error('Both x and y cannot have aggregate');
      } else {
        if (isMarkDef(mark) && mark.orient) {
          return mark.orient;
        } // default orientation = vertical


        return 'vertical';
      }
    } // x is continuous but y is not


    return 'horizontal';
  } else if (isFieldDef(encoding.y) && isContinuous(encoding.y)) {
    // y is continuous but x is not
    return 'vertical';
  } else {
    // Neither x nor y is continuous.
    throw new Error('Need a valid continuous axis for ' + compositeMark + 's');
  }
}